import { useState } from "react";
import { useSnackbar } from "notistack";
import { useApolloClient } from "@apollo/client";
import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { classes } from "@/partner/shared/ui/StyledRoot";
import { StyledRoot } from "@/partner/shared/ui";
import { config } from "@/partner/shared/constants";

import { SignInForm } from "./../../domains/SignInForm";
import { VerifyEmailForm } from "./../../domains/VerifyEmailForm";

export function SignIn() {
  const { t } = useTranslation();
  const [token, setToken] = useState<string>();
  const [lastSignInInput, setLastSignInInput] = useState<{
    email?: string;
  }>();
  const { enqueueSnackbar } = useSnackbar();
  const client = useApolloClient();

  const onSignInSuccess = (data: any, input?: { email?: string }) => {
    enqueueSnackbar(t("auth.snackbar.codeSent"), {
      variant: "success",
    });

    setToken(data.signIn.token);

    if (input) {
      setLastSignInInput(input);
    }
  };

  const onVerifyEmailSuccess = (data: any) => {
    localStorage.setItem("token", data.verifySignIn.token);
    enqueueSnackbar(t("auth.snackbar.signedIn"), { variant: "success" });
    client.resetStore();
  };

  const handleGoBack = () => {
    setToken(undefined);
    setLastSignInInput(undefined);
  };

  const getContactInfo = () => {
    if (lastSignInInput?.email) {
      return {
        contactType: "email" as const,
        contactInfo: lastSignInInput.email,
      };
    }

    return {
      contactType: "email" as const,
      contactInfo: "",
    };
  };

  const { contactType, contactInfo } = getContactInfo();

  return (
    <StyledRoot className={classes.root}>
      <div className={classes.form}>
        <Paper
          sx={{
            padding: 4,
            borderRadius: 2,
          }}
        >
          <Box sx={{ mb: 3, textAlign: "center" }}>
            <img
              src={config.logoUrl}
              alt={t("shared.logo.alt")}
              style={{ maxWidth: "150px", marginBottom: "16px" }}
            />
            <Typography variant="h5">{t("auth.signIn.title")}</Typography>
          </Box>

          {token ? (
            <VerifyEmailForm
              onCompleted={onVerifyEmailSuccess}
              token={token}
              // onResendCode={handleResendCode}
              onGoBack={handleGoBack}
              contactInfo={contactInfo}
              contactType={contactType}
            />
          ) : (
            <SignInForm onCompleted={onSignInSuccess} />
          )}
        </Paper>
      </div>
    </StyledRoot>
  );
}
